export const ArrowToRight = () => {
  return (
    <svg
      width={"1em"}
      height={"1em"}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.9999 5H16.6666V15H14.9999V5ZM8.33325 9.16667H3.33325V10.8333H8.33325V15L13.3333 10L8.33325 5V9.16667Z"
        fill="black"
      />
    </svg>
  );
};
